import { useState } from "react"
import Button from "../../../../../common/Button"
import CustomSelectAsyncSingle from "../../../../../common/interactive/CustomSelectAsyncSingle"
import CreateLiability from "../../../../../patient/details/liability/CreateLiability"
import { assignCaseLiability, assignCaseMedPayUM, caseQuickUpdate } from "../../../../../../lib/fetchApi"
import { caseActions } from "../../../../../../store/case"
import { useDispatch, useSelector } from "react-redux"
import { notificationActions } from "../../../../../../store/notifications"
import { policeReportFunctions } from "../../../../../../lib/policeReport"


export default function AsignCreateInsurance({classes, item, folder, apiCase, permission}) {
    const dispatch = useDispatch()
    const [searchInsurance, setSearchInsurance] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const selectedWorkQueue = useSelector(state => state.workqueue.selectedWorkQueue)
    const workqSlug = selectedWorkQueue?.slug || selectedWorkQueue

    if (policeReportFunctions.isMoonbirdReportProcessed(activeCase)) {
        return null
    }

    function searchInsuranceHandler(value) {
        setSearchInsurance(value)
    }

    function asignInsuranceHandler() {
        asignHandler(folder, searchInsurance?.data?.value)
    }


    const asignHandler = async (folder, insuranceId) => {

        if (insuranceId) {
            setIsLoading(true)

            try {
            // need to change api based on tab since Liabilities, Medpay, Um uses the same insurance api 

            if (folder == 'liabilities') {
                let reqBody = {
                    insurance_carrier_id: insuranceId,//required
                    location_id: null,
                    adjuster_id: null 
                }
                const asignedItem = await assignCaseLiability(userToken, activeCase.case.id, reqBody)
    
                if (asignedItem?.id) {
                    dispatch(caseActions.insertLiabilityInActiveCase(asignedItem))

                    setSearchInsurance(null)

                    let reqBody = {
                        type: 'case_liability',
                        type_id: asignedItem.id,
                        workq: workqSlug,
                        fields: {
                            policy_number: item.policy_number,
                            insured_name: item.name_on_policy,
                        }
                    }
                    const updatedItem = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch, true)

                    if (updatedItem && updatedItem.errorMessage) {
                        dispatch(notificationActions.setError(updatedItem))
                    } else {
                        let dispatchBody = {
                            folder: 'liabilities',
                            item: {
                                itemId: asignedItem.id,
                                fields: [
                                    {
                                        field: 'policy_number',
                                        value: item.policy_number,
                                    },
                                    {
                                        field: 'insured_name',
                                        value: item.name_on_policy,
                                    }
                                ]
                            }
                        }
                        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                    }
                } else {
                    dispatch(notificationActions.setError(asignedItem))
                }
            } 

            if (folder == 'mp_pip_um') {
                const asignedItem = await assignCaseMedPayUM(userToken, activeCase.case.id, {
                    insurance_carrier_id: insuranceId,//required
                    location_id: null,
                    adjuster_id: null 
                })

                if (asignedItem?.id) {
                    // dispatch(attorneyActions.setAssignedAttorney(attorney))
                    dispatch(caseActions.insertMedPayUMInActiveCase(asignedItem))    
                    setSearchInsurance(null)

                    let reqBody = {
                        type: 'case_mp_pip_um',
                        type_id: asignedItem.id,
                        workq: workqSlug,
                        fields: {
                            policy_number: item.policy_number,
                            insured_name: item.name_on_policy,
                        }
                    }
                    const updatedItem = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch, true)

                    if (updatedItem && updatedItem.errorMessage) {
                        dispatch(notificationActions.setError(updatedItem))
                    } else {
                        let dispatchBody = {
                            folder: 'mp_pip_um',
                            item: {
                                itemId: asignedItem.id,
                                fields: [
                                    {
                                        field: 'policy_number',
                                        value: item.policy_number,
                                    },
                                    {
                                        field: 'insured_name',
                                        value: item.name_on_policy,
                                    }
                                ]
                            }
                        }
                        dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                    }
                } else {
                    dispatch(notificationActions.setError(asignedItem))
                }
            } 

            } finally {
                setIsLoading(false)
            }
        } 
    }

    return <div className="flex-container">
        <CustomSelectAsyncSingle label={'Insurances Search'} path={'insurance-carriers'} action={searchInsuranceHandler} />
        <Button click={asignInsuranceHandler}  isLoading={isLoading} loaderType={'dark'}>Asign</Button>
        {/* <Button click={createInsuranceHandler} btnStyle={'btn_light_grey'} isLoading={isLoading} loaderType={'dark'}><i className="ti ti-plus"></i> Create</Button> */}
        <CreateLiability folder={folder} apiCase={apiCase} permission={'create_insurance'}/>
    </div>
}